module.exports = __webpack_public_path__ + "img/banner2_1.c5c31ae5.png";